import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    UndoCheckOutInput,
    UndoCheckOutMutationResponse,
} from "@/Domains/BookingManagement/Booking/Shared/Mutations/__generated__/UndoCheckOutMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: UndoCheckOutInput,
    onCompleted: (error: Error | null, result?: boolean | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation UndoCheckOutMutation($input: UndoCheckOutInput!) {
                UndoCheckOutMutation(input: $input)
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as UndoCheckOutMutationResponse;
            const success = res.UndoCheckOutMutation;

            if (success) {
                onCompleted(null, true);
                return;
            }

            throw new BaseError(
                "UndoCheckOutMutation failed with an unexpected Error",
                {
                    context: {
                        bookingId: input.bookingId,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
